import React from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import slugify from "slugify";

var configs = require("../../../public/config.json");

import NavBar, { ElementsWrapper } from "locale-scrolling-nav";
import Api from "../../lib/componentApi";
import mixpanel from "../../lib/mixPanel";

import { GlobalConsumer } from "../../context/GlobalContext";

import DeliveryDetails from "./DeliveryDetails";
import EnterPostCode from "./EnterPostCode";

import RestaurantInfo from "./Info";
import RestaurantMenu from "./Menu";
import AllergyInfo from "./AllergyInfo";
import SubmitItem from "../../routes/screens/Restaurants/Products/SubmitItem";

import DesktopCheckout from "../Common/DesktopCheckout";
import RestaurantLoading from "../Loadings/Restaurant";

import getAppStrings from "../../lib/appStrings";

import AppErrors from "../Common/AppErrors";
import AppInfo from "../Common/AppInfo";
import Reviews from "./Reviews";
import MoreDropdown from "./MoreDropdown";
import DeliverIn from "./DeliverIn";
import DeliverTo from "./DeliverTo";

import ItemSection from "./components/Detail/ItemSection";
import RestaurantHead from "./components/Detail/RestaurantHead";
import RestaurantBody from "./components/Detail/RestaurantBody";
import StickyMenu from "./components/Detail/StickyMenu";
import TabBar from "./components/Detail/TabBar";
import AllergyDetail from "./components/Detail/AllergyDetail";
import getRestaurantClosedStatusMessageCode from "../../lib/getRestaurantClosedStatusCode";
import getCompletedStatus from "../../lib/getRestaurantCompletedStatus";

import GlobalErrorPopup from "../Common/GlobalErrorPopup";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    const enabledMenus = this.getEnabledMenu();
    this.state = {
      scrolled: false,
      padding: 70,
      errorMessage: null,
      errorTitle: null,
      selectDelivery: props.selectDelivery,
      infoSection: false,
      menuFilter: false,
      selectedTab: "menu",
      closedMessage: props.closedMessage,
      closedTitle: props.closedTitle,
      offset: -180,
      addedFavorite:
        props.restaurant &&
        props.restaurant.isFavorite &&
        props.restaurant.isFavorite,
      navListWidth: 0,
      moreMenuItem: false,
      enabledMenus,
      enabled: [],
      disabled: [],
      reviewSection: false,
      disableSelected: null,
      maxDistance: configs.maxSearchDistanceValue || 2,
      defaultDistance: configs.defaultSearchDistanceValue || 1,
      preOrderStart: configs.preOrderStartDelay || 0,
      preOrderEnd: configs.preOrderEndInterval || 0,
      allergyInfo: false
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.closedMessage !== prevState.closedMessage) {
      return {
        closedMessage: nextProps.closedMessage
      };
    }
    if (nextProps.closedTitle !== prevState.closedTitle) {
      return {
        closedTitle: nextProps.closedTitle
      };
    }

    return null;
  }
  handleHistoryBack = event => {
    event.preventDefault();
    if (window) {
      history.back();
    }
  };
  componentDidMount() {
    const { restaurant, postalCode } = this.props;
    mixpanel.people.set({
      "Last Visited Restaurant": restaurant.name,
      Platform: "Web"
    });

    mixpanel.track("Restaurant Detail Screen", {
      Postcode: postalCode,
      Milage: restaurant.distance,
      "Min Order Amount": restaurant.minOrderAmount,
      Rank: restaurant.avgScore,
      Status: (restaurant.restaurantStatusCode && "Offline") || "Online"
    });
    window.addEventListener("scroll", this.listenScrollEvent);
    window.addEventListener(
      "resize",
      this.debounce(this.listenResizeEvent, 1000),
      {
        passive: true
      }
    );
    try {
      Api.post("/api/restaurant/visit/log", { restaurantUid: restaurant.uid });
    } catch (error) {
      console.log(error);
    }

    const element = document.getElementById("content");
    this.listenResizeEvent();
    this.setState({
      padding:
        (element &&
          element.scrollHeight &&
          element.scrollHeight < 1000 &&
          "20px") ||
        "20px"
    });
  }
  onClickMenuItem = menuId => {
    this.setState({ menuFilter: false }, () => {
      // eslint-disable-next-line
      if (__isBrowser__ && menuId) {
        const menuTitleId = `${menuId}-menu`;
        const element = document.getElementById(menuTitleId);
        if (element) {
          let minusScroll = 361;
          if (document.querySelector(".rewards")) {
            minusScroll += 35;
            console.log("minus " + minusScroll);
          }
          let top = element.offsetTop - minusScroll;
          console.log("element " + element.offsetTop);
          console.log("window" + window.innerHeight);
          console.log("top" + top);
          window.scrollTo(0, top);
        }
      }
    });
  };
  listenScrollEvent = e => {
    e.preventDefault();
    /* scrolled in ne zaman true olacağı ve css 'i değiştireceğini buradan ayarlayacağız. */
    if (window && window.scrollY > 200) {
      this.setState({
        scrolled: true
      });
    } else {
      this.setState({ scrolled: false });
    }
  };
  debounce = (fn, time) => {
    let timeout;
    return function() {
      const functionCall = () => fn.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  };
  listenResizeEvent = () => {
    const { enabledMenus } = this.state;
    const element = document.getElementById("main-list-element");
    const listWidth =
      enabledMenus && enabledMenus.length && element && element.offsetWidth;
    const container = document.getElementById("container");
    if (container) {
      const bodyWith = container.offsetWidth;
      const moreWidth =
        (document.getElementById("more") &&
          document.getElementById("more").offsetWidth) ||
        300;
      const listItems =
        (enabledMenus &&
          enabledMenus.length &&
          document.getElementsByClassName("main-list-item")) ||
        [];
      let enabled = [],
        disabled = [];
      let sum = moreWidth;
      if (bodyWith >= listWidth + moreWidth) {
        const dec = bodyWith - (listWidth + moreWidth);
        let { enabled, disabled } = this.state;
        const nextWidth =
          (document.getElementById(disabled[0]) &&
            document.getElementById(disabled[0]).offsetWidth) ||
          100;

        if (dec >= nextWidth && disabled[0]) {
          enabled.push(disabled[0]);
          disabled = disabled.filter(
            disableItem => disableItem.id !== disabled[0].id
          );
          this.setState({
            enabled,
            disabled
          });
        }
      } else {
        for (var i = 0; i < listItems.length; i++) {
          let first = listItems[i].clientWidth;
          sum += first;
          if (sum <= bodyWith) {
            enabled.push(enabledMenus[i]);
          } else {
            disabled.push(enabledMenus[i]);
          }
        }
        this.setState({
          enabled,
          disabled
        });
      }
    }
  };
  handleClickReviews = () => {
    const { isMobile } = this.props;
    if (isMobile) {
      this.setState({
        reviewSection: true
      });
    } else {
      this.setState({
        selectedTab: "reviews"
      });
    }
  };
  handleClickMenuItem = (index, width, disabledElement) => {
    const { disabled } = this.state;
    const item =
      (disabledElement &&
        disabled &&
        disabled.length &&
        disabled[index] &&
        disabled[index]) ||
      null;
    this.setState({
      disableSelected: (item && item.name) || null
    });
  };
  handleToggleFavorites = event => {
    event.preventDefault();
    const { restaurant } = this.props;
    const { addedFavorite } = this.state;
    let restaurantUid = restaurant.uid;
    let url =
      (addedFavorite && "/api/favorites/delete") || "/api/favorites/add";
    let data;
    if (url) {
      if (addedFavorite) {
        data = {
          restaurantUidList: JSON.stringify([restaurantUid])
        };
      } else {
        data = {
          restaurantUid
        };
        mixpanel.track("Add Favorites", { _restaurantName: restaurant.name });
      }
      if (data) {
        Api.post(url, data, (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            console.log(response);
          } else {
            if (response.status) {
              this.setState({ addedFavorite: !addedFavorite });
            }
          }
        });
      }
    }
  };
  handleOpenMenuFilter = () => {
    this.setState({ menuFilter: true }, () => {
      mixpanel.track("Restaurant Menu List");
    });
  };
  handleToggleDeliveryDetails = status => {
    var body = document.body;
    if (status) {
      body.classList.add("body-overflow");
      this.setState({ selectDelivery: true });
    } else {
      body.classList.remove("body-overflow");
      this.setState({
        selectDelivery: false
      });
    }
  };
  getEnabledMenu = () => {
    const { items, menus } = this.props.restaurant || [];
    let groupleMenu = [];
    if (menus && menus.length) {
      menus.forEach(menu => {
        const data = {
          name: menu.name,
          index: menu.index,
          label: menu.name,
          target: menu.id.toString(),
          id: menu.id,
          menuItems: items.filter(item => {
            const sameMenu = item.menus.filter(
              itemMenu => itemMenu.restaurantMenuId === menu.id
            );
            if (sameMenu.length) {
              return item;
            }
          })
        };
        groupleMenu.push(data);
      });
      const sortedArray = groupleMenu
        .filter(menu => menu.menuItems.length)
        .sort((first, next) => first.index - next.index);
      return sortedArray;
    }
  };
  renderRestaurantMenu = basketData => {
    const { items, menus } = this.props.restaurant || [];

    const { onSelectItem, restaurant } = this.props;
    let groupleMenu = [];
    menus.forEach(menu => {
      const data = {
        title: menu.name,
        index: menu.index,
        label: menu.name,
        target: menu.id.toString(),
        id: menu.id.toString(),
        menuItems: items.filter(item => {
          const sameMenu = item.menus.filter(
            itemMenu => itemMenu.restaurantMenuId === menu.id
          );
          if (sameMenu.length) {
            const selected =
              basketData &&
              basketData.items &&
              basketData.items.length &&
              basketData.items.find(
                selectedItem =>
                  selectedItem.item_id === item.id ||
                  selectedItem.restaurantItemId === item.id
              );
            item.selected = selected && selected.quantity;
            return item;
          }
        })
      };
      groupleMenu.push(data);
    });
    const sortedArray = groupleMenu
      .filter(menu => menu.menuItems.length)
      .sort((first, next) => first.index - next.index);
    let closedStatus = false;

    if (restaurant.restaurantStatusCode) {
      let closedStatusMessageCode = getRestaurantClosedStatusMessageCode(
        restaurant.restaurantStatusCode
      );
      closedStatus = getAppStrings(closedStatusMessageCode) || {
        message: "This restaurant is temporarily offline."
      };
    }
    const { pathname, search } = this.props.location;
    return (
      <ElementsWrapper items={sortedArray}>
        {sortedArray.length &&
          sortedArray.map((menu, index) => (
            <div name={menu.id} key={index} className="white-bg detail-item">
              <h4 id={`${menu.id}-menu`}>{menu.title}</h4>

              {menu.menuItems.map(item => {
                let itemEnabled = item.enabled && !item.disabledUntil;
                let className = (!itemEnabled && "line-through") || "";
                const link = `${item.id}-${item.name.toLowerCase()}`;
                const hash = slugify(link, {
                  replacement: "-"
                });
                return (
                  <div
                    className="title cursor-pointer"
                    key={item.id}
                    id={item.id}
                    onClick={() =>
                      (itemEnabled &&
                        onSelectItem(
                          item.id,
                          closedStatus.message,
                          item.name
                        )) || <noscript />
                    }
                  >
                    <ItemSection
                      pathname={pathname}
                      search={search}
                      hash={hash}
                      className={className}
                      item={item}
                      itemEnabled={itemEnabled}
                    />
                  </div>
                );
              })}
            </div>
          ))}
      </ElementsWrapper>
    );
  };
  handleOpenInfo = () => {
    this.setState({ infoSection: true }, () => {
      mixpanel.track("Restaurant Detail Screen", {
        _source: "Info"
      });
    });
  };
  handleCloseError = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({ errorMessage: null });
  };
  getPictureUrl = (url, width, height) => {
    let replacedWidth = (url && url.replace("[WIDTH]", width)) || "";
    const newUrl =
      (replacedWidth && replacedWidth.replace("[HEIGHT]", height)) || "";
    return newUrl;
  };

  handleSelectedTab = tabName => {
    const { selectedTab } = this.state;
    if (selectedTab !== tabName) {
      this.setState({
        selectedTab: tabName
      });
    }
  };
  handleAllergyInfo = () => {
    const { allergyInfo } = this.state;
    var body = document.body;
    if (allergyInfo) {
      body.classList.remove("body-overflow");
    } else {
      body.classList.add("body-overflow");
    }
    this.setState({
      allergyInfo: !allergyInfo
    });
  };
  handleBasket = () => {
    window.location.href = "/checkout";
  };
  renderCheckOut = basketData => {
    const { subTotal: allAmount, items } = basketData;

    return (
      (items && items.length && (
        <div className="fixed-btn view-basket-btn">
          <a className="cursor-pointer" onClick={() => this.handleBasket()}>
            <div>{basketData.items.length}</div>
            <div>
              <p>View Basket</p>
            </div>
            <div>£{parseFloat(allAmount).toFixed(2)}</div>
          </a>
        </div>
      )) ||
      null
    );
  };
  onCloseInfo = () => {
    this.setState({ infoSection: false });
  };
  handleNewPlace = link => {
    if (link.status === "close") {
      window.location.replace("/");
    } else {
      window.location.replace(link);
    }
  };
  handleCloseReviews = () => {
    this.setState({
      reviewSection: false
    });
  };
  handleClickReward = () => {
    mixpanel.track("Reward Label Click");
  };
  getSpendAmount = (basketData, totalSpendAmount) => {
    const calculatedSpend =
      (basketData &&
        basketData.subTotal &&
        totalSpendAmount - basketData.subTotal) ||
      totalSpendAmount;
    return (
      (calculatedSpend &&
        calculatedSpend > 0 &&
        parseFloat(calculatedSpend).toFixed(2)) ||
      "0.00"
    );
  };
  onClickDeliveredBy = (event, restaurantName) => {
    event.preventDefault();
    event.stopPropagation();
    const strings = getAppStrings(3031);
    if (strings) {
      const deliveredByMessage = strings.message;
      const deliveredByTitle = strings.title.replace("[:par1]", restaurantName);
      var body = document.body;
      body.classList.add("body-overflow");
      this.setState({
        errorMessage: deliveredByMessage,
        errorTitle: deliveredByTitle
      });
    }
  };
  render() {
    const {
      restaurant,
      routeName,
      postalCode,
      addressLine2,
      userAddressId,
      delivery,
      preOrder,
      onCloseItem,
      itemId,
      addItem,
      onClickClose,
      enterPostCode,
      infoMessage,
      handleClearBasket,
      closeInfoMessage,
      isAlive,
      isMobile,
      getRestaurantItems
    } = this.props;
    const {
      scrolled,
      selectDelivery,
      infoSection,
      menuFilter,
      addedFavorite,
      padding,
      errorMessage,
      selectedTab,
      closedMessage,
      closedTitle,
      disabled,
      enabled,
      enabledMenus,
      offset,
      defaultDistance,
      maxDistance,
      preOrderEnd,
      preOrderStart,
      disableSelected,
      allergyInfo,
      reviewSection,
      errorTitle
    } = this.state;
    const {
      deal,
      avgScore,
      name,
      minOrderEnabled,
      minOrderAmount,
      reviewCount,
      pictures,
      openingHours,
      info,
      types,
      deliveryFee,
      uid,
      slugName,
      restaurantStatusCode,
      restaurantStatusParams
    } = restaurant || "";
    const completedStatus = getCompletedStatus({
      restaurantStatusCode,
      restaurantStatusParams
    });

    const { url } = (pictures && pictures.length && pictures[0]) || "";
    const avgClassName = `avg-score s${parseInt(avgScore)}`;
    const commentsClassName = `comments s${parseInt(avgScore)} cursor-pointer`;
    const buttonText = "Clear Basket";
    const title = "Start new order?";

    return (
      (infoSection && (
        <RestaurantInfo
          info={info}
          openingHours={openingHours}
          closedStatus={completedStatus}
          restaurantName={name}
          restaurantUid={uid}
          isMobile={isMobile}
          onCloseInfo={this.onCloseInfo}
        />
      )) ||
      (menuFilter && (
        <RestaurantMenu
          menus={enabledMenus}
          onClickMenuItem={this.onClickMenuItem}
        />
      )) ||
      (reviewSection && (
        <Reviews
          restaurantUid={restaurant.uid}
          handleCloseReviews={this.handleCloseReviews}
          restaurantName={restaurant.name}
        />
      )) ||
      (restaurant && (
        <GlobalConsumer>
          {({ basketData, user, updateBasket }) => (
            <>
              <div className="container">
                <Helmet>
                  <title>{name}</title>
                  <meta property="og:title" content={name} />
                </Helmet>

                <div className="row">
                  <div className="col-sm-9">
                    <div
                      style={{ paddingBottom: padding }}
                      className={`restaurant-detail ${(scrolled &&
                        "scrolled") ||
                        ""}`}
                    >
                      <RestaurantHead
                        completedStatus={completedStatus}
                        postalCode={postalCode}
                        addedFavorite={addedFavorite}
                        url={url}
                        getPictureUrl={this.getPictureUrl}
                        handleHistoryBack={this.handleHistoryBack}
                        handleToggleFavorites={this.handleToggleFavorites}
                      />

                      <RestaurantBody
                        scrolled={scrolled}
                        types={types}
                        name={name}
                        minOrderEnabled={minOrderEnabled}
                        minOrderAmount={minOrderAmount}
                        avgScore={avgScore}
                        commentsClassName={commentsClassName}
                        reviewCount={reviewCount}
                        avgClassName={avgClassName}
                        completedStatus={completedStatus}
                        info={info}
                        handleOpenInfo={this.handleOpenInfo}
                        handleClickReviews={this.handleClickReviews}
                        deliveryType={restaurant.deliveryType}
                        onClickDeliveredBy={this.onClickDeliveredBy}
                      />
                      <StickyMenu
                        deal={deal}
                        restaurantName={restaurant.name}
                        basketData={basketData}
                        routeName={routeName}
                        postalCode={postalCode}
                        delivery={delivery}
                        preOrder={preOrder}
                        userAddressId={userAddressId}
                        addressLine2={addressLine2}
                        handleToggleDeliveryDetails={
                          this.handleToggleDeliveryDetails
                        }
                        getSpendAmount={this.getSpendAmount}
                        handleClickReward={this.handleClickReward}
                        handleOpenMenuFilter={this.handleOpenMenuFilter}
                      />

                      {(selectedTab === "menu" && (
                        <div className="hide-xs">
                          <div className="menu-filter">
                            <div id="container" className="container">
                              <ul className="d-flex align-items-center">
                                <React.Fragment>
                                  {((enabled && enabled.length) ||
                                    (enabledMenus && enabledMenus.length)) && (
                                    <NavBar
                                      position="absolute"
                                      items={
                                        (enabled.length && enabled) ||
                                        enabledMenus
                                      }
                                      linkClass="nav-menu-link"
                                      activeLinkClass="active"
                                      wrapperListElementClass="main-list-item"
                                      wrapperUlClass="main-list-element"
                                      offset={offset}
                                      duration={500}
                                      delay={0}
                                      height={45}
                                      handleClick={this.handleClickMenuItem}
                                    />
                                  )}
                                  {(disabled && disabled.length && (
                                    <li id="more">
                                      <MoreDropdown
                                        list={disabled}
                                        name={disableSelected || "More"}
                                        handleClick={this.handleClickMenuItem}
                                      />
                                    </li>
                                  )) || <noscript />}
                                </React.Fragment>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )) || <noscript />}

                      <TabBar
                        selectedTab={selectedTab}
                        avgScore={avgScore}
                        handleSelectedTab={this.handleSelectedTab}
                      />

                      {(selectedTab === "menu" &&
                        ((enabledMenus && (
                          <div>
                            {this.renderRestaurantMenu(basketData)}
                            <AllergyDetail
                              handleAllergyInfo={this.handleAllergyInfo}
                            />
                            {(allergyInfo && (
                              <AllergyInfo
                                contactMobileNumber={
                                  restaurant.contactMobileNumber
                                }
                                onClickClose={this.handleAllergyInfo}
                              />
                            )) || <noscript />}
                          </div>
                        )) || <noscript />)) || <noscript />}
                      {(selectedTab === "info" && (
                        <RestaurantInfo
                          info={info}
                          openingHours={openingHours}
                          closedStatus={completedStatus}
                          restaurantName={name}
                          restaurantUid={uid}
                          isMobile={isMobile}
                          onCloseInfo={this.onCloseInfo}
                        />
                      )) || <noscript />}
                      {(selectedTab === "reviews" && (
                        <Reviews restaurantName={name} restaurantUid={uid} />
                      )) || <noscript />}

                      {this.renderCheckOut(basketData)}
                    </div>
                    {/* .restaurant-detail */}
                  </div>
                  {/* .col-sm-9 */}
                  <div className="col-sm-3 sidebar right-sidebar mt-10px hide-xs">
                    <div className={(scrolled && "fixed") || ""}>
                      <div className="white-bg delivery-sidebar">
                        <div className="delivery-to">
                          <div className="d-flex align-items-center justify-content-between">
                            <h5>Deliver to:</h5>
                          </div>

                          <React.Fragment>
                            <a className="cursor-pointer">
                              <DeliverTo route="detail" slugName={slugName} />
                            </a>
                          </React.Fragment>
                        </div>

                        <div className="">
                          <h5>Deliver in:</h5>
                          <a className="cursor-pointer">
                            <DeliverIn
                              preOrderStart={preOrderStart}
                              preOrderEnd={preOrderEnd}
                            />
                          </a>
                        </div>
                      </div>

                      {(basketData && basketData.items && (
                        <DesktopCheckout
                          basketData={basketData}
                          updateBasket={updateBasket}
                          scrolled={scrolled}
                          getRestaurantItems={getRestaurantItems}
                        />
                      )) || <noscript />}
                    </div>
                  </div>
                  {/* .col-sm-3 */}
                </div>
                {/* .row */}
              </div>
              <div>
                {(enterPostCode && (
                  <EnterPostCode
                    onClose={this.handleNewPlace}
                    slugName={slugName}
                    route="detail"
                  />
                )) || <noscript />}
                {(closedMessage && (
                  <AppErrors
                    title={closedTitle || "Restaurant Offline"}
                    message={closedMessage}
                    onClickClose={onClickClose}
                  />
                )) || <noscript />}
                {(selectDelivery && (
                  <DeliveryDetails
                    onCloseSection={() =>
                      this.handleToggleDeliveryDetails(false)
                    }
                    route="detail"
                    slugName={slugName}
                    maxDistance={maxDistance}
                    defaultDistance={defaultDistance}
                    preOrderStart={preOrderStart}
                    preOrderEnd={preOrderEnd}
                  />
                )) || <noscript />}
                {(errorMessage && (
                  <AppErrors
                    title={errorTitle || ""}
                    message={errorMessage}
                    onClickClose={this.handleCloseError}
                  />
                )) || <noscript />}
                {(addItem &&
                  ((enterPostCode && (
                    <EnterPostCode
                      onClose={this.handleNewPlace}
                      slugName={slugName}
                      route="detail"
                    />
                  )) ||
                    (!isAlive && (
                      <GlobalErrorPopup onClickClose={closeInfoMessage} />
                    )) ||
                    (infoMessage && (
                      <AppInfo
                        message={infoMessage}
                        title={title}
                        onClickClose={closeInfoMessage}
                        buttonText={buttonText}
                        onSubmit={() => handleClearBasket(updateBasket)}
                      />
                    )) || (
                      <SubmitItem
                        itemId={itemId}
                        onCloseItem={onCloseItem}
                        restaurantId={uid}
                        restaurantName={name}
                        deliveryFee={deliveryFee}
                        basketData={basketData}
                        restaurantAddress={restaurant.address}
                        allAddresses={user && user.addresses}
                        slugName={slugName}
                        getRestaurantItems={getRestaurantItems}
                      />
                    ))) || <noscript />}
              </div>
            </>
          )}
        </GlobalConsumer>
      )) || <RestaurantLoading />
    );
  }
}

export default withRouter(Detail);
